import { useSyncExternalStore } from 'react';

// ════════════════════════════════════════════════════════════════════════════
// M.1 — Decide qué experiencia se renderiza: Mobile o Desktop.
//
// Criterio: ANCHO DE VIEWPORT, no User-Agent. Un teléfono en horizontal, una
// tablet o una ventana Desktop reducida reciben la experiencia que su ancho
// real permite, y Chrome Device Mode cambia de experiencia en vivo.
//
// Breakpoint: < 768px = Mobile. 768px (iPad vertical) en adelante = Desktop.
//   - Todos los teléfonos en vertical (320–430px) caen en Mobile.
//   - 768px ya tenía una adaptación Desktop propia (styles.js, sidebar 200px)
//     que se conserva sin cambios; tablets grandes no se degradan a Mobile.
//   - 767.98 (y no 767) evita el hueco con anchos fraccionarios por zoom/DPR.
//
// Se usa matchMedia (no un listener de resize): el navegador sólo notifica al
// cruzar el breakpoint. useSyncExternalStore mantiene una sola fuente de verdad
// sin estado duplicado ni efectos manuales.
// ════════════════════════════════════════════════════════════════════════════

export const BREAKPOINT_MOBILE_PX = 768;
export const QUERY_MOBILE = `(max-width: ${BREAKPOINT_MOBILE_PX - 0.02}px)`;

function obtenerMql() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(QUERY_MOBILE);
}

function suscribir(callback) {
  const mql = obtenerMql();
  if (!mql) return () => {};
  if (mql.addEventListener) {
    mql.addEventListener('change', callback);
    return () => mql.removeEventListener('change', callback);
  }
  // Safari < 14
  mql.addListener(callback);
  return () => mql.removeListener(callback);
}

function leer() {
  const mql = obtenerMql();
  return mql ? mql.matches : false;
}

export function useEsMobile() {
  return useSyncExternalStore(suscribir, leer, () => false);
}
